import cx from 'clsx';
import React from 'react';
import { Box, getRadius, rem } from '@mantine/core';
import type { FlagProps } from '../types';
import classes from '../flagpack.module.css';

export function EEFlag({ radius, className, size, ...others }: FlagProps) {
  return (
    <Box
      className={cx(classes.flag, className)}
      __vars={{ '--flag-radius': getRadius(radius), '--flag-size': rem(size) }}
      {...others}
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 24">
        <defs>
          <mask id="mantine-7bulofjjn" fill="#fff">
            <path fillRule="evenodd" d="M0 0h32v24H0z" />
          </mask>
          <mask id="mantine-lao7ly7bb" fill="#fff">
            <use fillRule="evenodd" xlinkHref="#mantine-328leieju" />
          </mask>
          <path id="mantine-328leieju" d="M0 0h32v24H0z" />
        </defs>
        <g fill="none" fillRule="evenodd" mask="url(#mantine-7bulofjjn)">
          <use fill="#f7fcff" xlinkHref="#mantine-328leieju" />
          <path fill="#40a8ff" d="M0 0h32v8H0z" mask="url(#mantine-lao7ly7bb)" />
          <path fill="#272727" d="M0 8h32v8H0z" mask="url(#mantine-lao7ly7bb)" />
        </g>
      </svg>
    </Box>
  );
}
